import { Suspense } from "react";
import Loading from "./MatxLoading";

export default function MatxSuspense({ children }) {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
}
